import { type ProductInterface, type FilterTableInterface } from "./productFilterMock.hook"

// ToDo: Change the interface types once the actual data is in.
interface OutputInterface {
  data: FilterTableInterface | null
}

export const useProductFilterData = (inputData: any[] | undefined): OutputInterface => {
  if (inputData?.length) {
    return {
      data: {
        headers: ["Add to FMP", "Element", "Application", "Product", "Service", "Nom Size", "Fitting Allowed", "Note", "FRL", "Report"],
        columns: inputData.reduce((accumulator, currentValue) => [...accumulator, { values: { ...currentValue } }], []) as ProductInterface[]
      }
    }
  }

  return {
    data: {
      headers: ["Add to FMP", "Element", "Application", "Product", "Service", "Nom Size", "Fitting Allowed", "Note", "FRL", "Report"],
      columns: []
    }
  }
}
